import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import currentUser from './currentUser';
import accounts from './accounts';
import entities from './entities';
import dialogs from './dialogs';
import verification from './verification';
import slateViews from './slateViews';
import slatePane from './slatePane';
import helpPane from './helpPane';
import jobs from './jobs';
import app from './app';
import images from './images';
import notifications_page from './notifications';
import inspect from './inspect';
import chatSession from './chatSession';

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    currentUser,
    accounts,
    entities,
    dialogs,
    verification,
    slateViews,
    slatePane,
    helpPane,
    jobs,
    app,
    images,
    notifications_page,
    inspect,
    chatSession,
  });

export default createRootReducer;
